import { createContext } from 'react';

const { Provider: ContextProvider, Consumer: ContextConsumer } = createContext(null);

export { ContextProvider, ContextConsumer };